import { z } from 'zod';

import { getBirthNumberErrorMessage } from './getBirthNumberErrorMessage';
import type { BirthNumberValidationParams } from './types/types';

const ZOD_CODE_ISSUE = 'custom';
const ZOD_CODE_PATH: PropertyKey[] = ['birthNumber'];

export const getBirthNumberZodError = (message: string) => {
	throw new z.ZodError([
		{
			message,
			code: ZOD_CODE_ISSUE,
			path: ZOD_CODE_PATH,
		},
	]);
};

export const birthNumberRefine = (params: BirthNumberValidationParams) => {
	const errorMessage = getBirthNumberErrorMessage(params);

	if (!errorMessage) return true;

	return getBirthNumberZodError(errorMessage);
};
